import React, {useContext, useState, useEffect, useRef} from 'react';
import i18n from 'i18next';
import {Trans} from "react-i18next";

import {isNSCSubdomain, playAudio} from "../../../../utils/Utils";
import routes from "../../../../constants/Routes";
import GLOBAL from "../../../../global";
import CONSTANT from "../../../../constants/Constant";

import AppContext from "../../../../contexts/AppContext";
import DefaultUserPic from "../../../../assets/img/users/img.png";
import DefaultUserColorPic from "../../../../assets/img/users/defaultColorImg.svg";

import flagUsa from "../../../../assets/img/flag/flag-usa.svg";
import flagSpain from "../../../../assets/img/flag/flag-spain.svg";

import Language from "../../../../assets/img/utils/language.png";
import MovementVoice from "../../MovementVoice";
import useSweetAlert from "../../Popups/sweetAlertComponent/useSweetAlert";
import authService from "../../../../services/AuthService";
// import {redirectTo} from "../../chatbotNew/ChatServices";
import Header from "../Header";
import {useHistory} from "react-router-dom";
import { useHandleDirectPayment } from "../../../../contexts/DirectPaymentContext";
import { useTenantFeatures } from "../../../../features/tenantFeatures/useTenantFeature";

import './MainHeaderWrapper.scss';

/**
 * Main header component for the application.
 *
 * This header is displayed across the entire site except for the login, register, and package pages,
 * which have their own dedicated headers. The `MainHeaderWrapper` dynamically adjusts its content
 * based on the user's authentication status and preferences such as language and audio settings.
 *
 * @returns {JSX.Element} The main header component.
 */

const MainHeaderWrapper = () => {

    const {
        authenticated,
        userInfo,
        deAuthenticate,
        isAudioPlayEnabled,
        audioPlayEnabled,
        // toggleShowLeftSideMenuInMobile,
        toggleShowTopNavigationInMobile
    } = useContext(AppContext);
    const {showSweetAlert, hideSweetAlert, setOkLoading} = useSweetAlert();
    const { clearDirectPaymentState } = useHandleDirectPayment();
    const [languageDropdownShow, setLanguageDropdownShow] = useState(false);
    const [profileDropdownShow, setProfileDropdownShow] = useState(false);
    // const [showOption, setShowOption] = useState(false)
    const [language, setLanguage] = useState(flagUsa);
    const history = useHistory();

    const headerRef = useRef(null);
    const { isSpinealignEnabled, backToMyBackHubButtonLink } = useTenantFeatures();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (headerRef.current && !headerRef.current.contains(event.target)) {
                setLanguageDropdownShow(false);
                setProfileDropdownShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const profileOptionsHandler = (option, value) => {
    //     const profileOptionsCopy = {...profileOptions, [option]: !value}
    //     setProfileOptions(profileOptionsCopy)
    // }

    const onClickSignOut = () => {
        playAudio('remove').then();
        GLOBAL.AUDIO_PLAY_ENABLED = false;
        audioPlayEnabled && audioPlayEnabled(false);
        deAuthenticate();
        clearDirectPaymentState();
        // redirectTo(routes.landing);
        history.push(routes.signIn);
    };

    const onChangeLanguage = (lng) => e => {
        e.preventDefault();

        if (lng === CONSTANT.LANGUAGES.ENGLISH.value) {
            setLanguage(flagUsa);

        } else if (lng === CONSTANT.LANGUAGES.SPANISH.value) {
            setLanguage(flagSpain);
        }

        i18n.changeLanguage(lng).then();
    };

    // const onClickShowLangKey = () => {
    //     i18n.changeLanguage('cimode').then();
    // };

    const languageDropdownToggle = (e) => {
        e.preventDefault();

        setProfileDropdownShow(false);
        setLanguageDropdownShow(!languageDropdownShow);
    }

    const profileDropdownToggle = (e) => {
        e.preventDefault();

        setLanguageDropdownShow(false);
        setProfileDropdownShow(!profileDropdownShow);
    };

    // const showOptionHandler = () => {
    //     setShowOption(prevState => !prevState)
    //     setProfileDropdownShow(false)
    // }

    const onChangeAudioPlay = () => {
        playAudio('remove').then();
        GLOBAL.AUDIO_PLAY_ENABLED = !isAudioPlayEnabled;
        audioPlayEnabled && audioPlayEnabled(!isAudioPlayEnabled);
    };

    const onClickDeleteProfile = () => {
        setProfileDropdownShow(false);

        showSweetAlert({
            message: 'Are you sure you want to delete your profile?',
            type: CONSTANT.ALERT_TYPE.WARNING,
            showConfirmBtn: true,
            showCancelBtn: true,
            confirmBtnText: "Yes",
            cancelBtnText: "No",
            textWhileProcessingConfirmBtn: "Deleting...",
            onConfirm: async () => {
                setOkLoading(true);
                await authService.deleteProfile();
                setOkLoading(false);
                hideSweetAlert();
                // redirectTo(routes.landing);
                history.push(routes.landing);
            },
            onCancel: () => {
                hideSweetAlert();
            },
        })
    }

    const onClickLogoutWithConfirm = () => {
        showSweetAlert({
            message: 'Are you sure you want to log out?',
            type: CONSTANT.ALERT_TYPE.WARNING,
            showConfirmBtn: true,
            showCancelBtn: true,
            confirmBtnText: 'Yes',
            cancelBtnText: 'No',
            textWhileProcessingConfirmBtn: 'Logging out...',
            onConfirm: async () => {
                setOkLoading(true);
                await onClickSignOut();
                setOkLoading(false);
                hideSweetAlert();
            },
            onCancel: () => {
                hideSweetAlert();
            },
        });
    };


    const getLogoutBtn = () => (
        <div className="main-header-wrapper__topbar-wrapper mmh-logout">
            {!isNSCSubdomain() ? (
                <button
                    className="button rounded-btn dashboard-header-logout-btn"
                    onClick={onClickLogoutWithConfirm}
                >
                    <Trans i18nKey="common.actions.logout" />
                </button>
            ) : (
                <a
                    className="btn-mybackhub"
                    href={backToMyBackHubButtonLink}
                >
                    Back to MyBackHUB
                </a>
            )}
        </div>
    );


    return (
        <Header>
            <div ref={headerRef} className="main-header-wrapper__topbar"
                 style={{
                     display: "flex",
                     alignItems: "center",
                     gap: "1rem"
                 }}
            >
                {authenticated && (
                    <>
                        <div
                            className={`main-header-wrapper__dropdown main-header-wrapper__dropdown--langs`}
                            onClick={(e) => {
                                e.stopPropagation();
                                setProfileDropdownShow(false);
                                setLanguageDropdownShow(!languageDropdownShow);
                            }}
                        >
                            <div className="main-header-wrapper__dropdown-toggle">
                                <span className="main-header-wrapper__topbar-icon">
                                    <i class="fa-solid fa-globe"></i>
                                </span>
                            </div>
                            {languageDropdownShow && (
                                <div
                                    className={`main-header-wrapper__dropdown-menu main-header-wrapper__dropdown-menu--fit main-header-wrapper__dropdown-menu--right main-header-wrapper__dropdown-menu--anim`}
                                    // style={{transform: "translate3d(-140px, 0px, 0px)"}}
                                >
                                    <div
                                        className={`main-header-wrapper__nav-item main-header-wrapper__nav-item--active`}>
                                        <a href={"!#"} rel="noopener noreferrer"
                                           className="main-header-wrapper__nav-link"
                                           onClick={onChangeLanguage(CONSTANT.LANGUAGES.ENGLISH.value)}>
                                            <p className="main-header-wrapper__nav-link-icon">
                                                    <img src={flagUsa} alt="Flag Pic"/>
                                            </p>
                                            <p className="main-header-wrapper__nav-link-text">English</p>
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="main-header-wrapper__topbar-item">
                            <div className="main-header-wrapper__topbar-wrapper">
                                {/*<MovementVoice isAudioPlayEnabled={isAudioPlayEnabled} onChangeAudioPlay={onChangeAudioPlay}/>*/}
                                {/*<EmmaVoice isAudioPlayEnabled={isAudioPlayEnabled} onChangeAudioPlay={onChangeAudioPlay} voiceId="checkbox-toggle-pill" />*/}
                            </div>
                        </div>


                        <div
                            className={`main-header-wrapper__dropdown main-header-wrapper__dropdown--user`}
                            onClick={(e) => {
                                e.stopPropagation();
                                setLanguageDropdownShow(false);
                                setProfileDropdownShow(!profileDropdownShow);
                            }}
                        >
                            <div className="main-header-wrapper__dropdown-toggle">
                                <span className={`main-header-wrapper__topbar-icon main-header-wrapper__img-rounded`}>
                                    {
                                        GLOBAL.USER_INFO?.['ProfilePic'] ?
                                            <img
                                                style={{
                                                    width: "3rem",
                                                }} className="main-header-wrapper__img-rounded" alt="Pic"
                                                src={GLOBAL.USER_INFO?.['ProfilePic']}/>:
                                            <i className="fa-regular fa-circle-user"></i>
                                    }
                                </span>
                            </div>
                            {profileDropdownShow && (
                                <div
                                    className={`main-header-wrapper__dropdown-menu main-header-wrapper__dropdown-menu--fit main-header-wrapper__dropdown-menu--right main-header-wrapper__dropdown-menu--anim main-header-wrapper__dropdown-menu--xl`}
                                    // style={{transform: "translate3d(-245px, 0px, 0px)"}}
                                >
                                    <div className="dashboard-header-user-profile">
                                        <div className="main-header-wrapper__user-card-avatar">
                                            {
                                                GLOBAL.USER_INFO?.['ProfilePic'] ?
                                                    <img
                                                        style={{
                                                            width: "3rem",
                                                        }} className="main-header-wrapper__img-rounded" alt="Pic"
                                                        src={GLOBAL.USER_INFO?.['ProfilePic']}/>:
                                                    <i className="fa-regular fa-circle-user"></i>
                                            }
                                        </div>
                                        <div className={`dashboard-header-user-profile-name main-header-wrapper__ml-3`}>
                                            {userInfo && (userInfo.FullName)}
                                        </div>
                                    </div>

                                    {
                                        !isSpinealignEnabled &&
                                        <div className="dashboard-header-user-profile cursor-pointer"
                                            onClick={onClickDeleteProfile}
                                        >
                                            <div className={`dashboard-header-user-profile-name main-header-wrapper__ml-3`}>
                                                <span>Delete My Profile</span>
                                            </div>
                                        </div>
                                    }
                                    <div
                                        className={`main-header-wrapper__d-flex main-header-wrapper__justify-content-center main-header-wrapper__align-items-center main-header-wrapper__flex-column`}>

                                        {/* Will be hidden for desktop and will show at mobile to tab */}
                                        <div className={`logout_btn_profile main-header-wrapper__pt-4`}>
                                            <div className="main-header-wrapper__topbar-item">
                                                {getLogoutBtn()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="main-header-wrapper__d-flex">
                            <div className="main-header-wrapper__mobile-toolbar">
                                <button
                                    id="mobile_menu_toggler"
                                    className="main-header-wrapper__mobile-toggler"
                                    onClick={toggleShowTopNavigationInMobile}
                                >
                                    <i class="fa-solid fa-list"></i>
                                </button>
                            </div>
                        </div>

                        {/* Will show in desktop and will be hidden for mobile to tab */}
                        <div
                            className={`main-header-wrapper__topbar-item logout_btn main-header-wrapper__align-items-center`}>
                            {getLogoutBtn()}
                        </div>
                    </>
                )}
            </div>
        </Header>
    )
};

export default MainHeaderWrapper;
